var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.showModalVisualizaPdf
        ? _c("app-modal-visualiza-pdf", {
            attrs: {
              titulo: _vm.tituloModal,
              tipo: _vm.tipoModal,
              conteudo: _vm.conteudoModal,
              isImagem: _vm.isImagem,
              tituloDocumento: _vm.tituloDocumento
            },
            on: { closeModal: _vm.closeModalVisualizaPdf }
          })
        : _vm._e(),
      _c("validation-observer", { ref: "validation", attrs: { tag: "div" } }, [
        _vm.laudo
          ? _c(
              "div",
              { staticClass: "content" },
              [
                _c(
                  "div",
                  { staticClass: "margim-bottom" },
                  [
                    _c(
                      "el-tooltip",
                      {
                        attrs: {
                          content: _vm.getLabel(_vm.laudo),
                          placement: "top"
                        }
                      },
                      [
                        !_vm.laudo.aptoParaGerar
                          ? _c("i", {
                              staticClass:
                                "header-icon el-icon-warning warning-icon"
                            })
                          : _vm._e()
                      ]
                    ),
                    _c(
                      "el-tooltip",
                      {
                        attrs: { content: "Apto para gerar", placement: "top" }
                      },
                      [
                        _vm.laudo.aptoParaGerar
                          ? _c("i", {
                              staticClass:
                                "header-icon el-icon-success success-icon"
                            })
                          : _vm._e()
                      ]
                    ),
                    _vm._v(
                      _vm._s("Laudo do processo " + _vm.laudo.numeroProcesso)
                    )
                  ],
                  1
                ),
                _c(
                  "el-card",
                  { staticClass: "content", attrs: { shadow: "hover" } },
                  [
                    _c("app-divider", {
                      staticClass: "margim-bottom",
                      attrs: { label: "Dados do processo" }
                    }),
                    _c(
                      "div",
                      { staticClass: "filter-row" },
                      [
                        _c("app-par", {
                          attrs: {
                            chave: "Número do processo",
                            valor: _vm.laudo.numeroProcesso
                          }
                        }),
                        _c(
                          "el-button",
                          {
                            attrs: { type: "primary" },
                            on: {
                              click: function($event) {
                                return _vm.visualizarProcesso(_vm.laudo)
                              }
                            }
                          },
                          [
                            _c("span", [
                              _c("i", { staticClass: "fal fa-eye" }),
                              _vm._v("  Visualizar Processo")
                            ])
                          ]
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-row",
                      [
                        _c("app-display-com-input", {
                          attrs: {
                            marginBottom: true,
                            label: "Número da OS",
                            content: _vm.numeroOs
                          },
                          on: {
                            "update:content": function($event) {
                              _vm.numeroOs = $event
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-row",
                      [
                        _c("app-display-com-input", {
                          attrs: {
                            marginBottom: true,
                            label: "Data vistoria",
                            content: _vm.laudo.dataVistoria
                          },
                          on: {
                            "update:content": function($event) {
                              return _vm.$set(_vm.laudo, "dataVistoria", $event)
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c("app-divider", {
                      staticClass: "margim-bottom",
                      attrs: { label: "Dados do interessado" }
                    }),
                    _c(
                      "el-row",
                      [
                        _c("app-display-com-input", {
                          attrs: {
                            marginBottom: true,
                            label: "Nome",
                            content: _vm.laudo.dadoLaudoDto.nomeRazaoSocial
                          },
                          on: {
                            "update:content": function($event) {
                              return _vm.$set(
                                _vm.laudo.dadoLaudoDto,
                                "nomeRazaoSocial",
                                $event
                              )
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-row",
                      [
                        _c("app-display-com-input", {
                          attrs: {
                            marginBottom: true,
                            label: "CPF",
                            content: _vm.laudo.dadoLaudoDto.cpfCnpj
                          },
                          on: {
                            "update:content": function($event) {
                              return _vm.$set(
                                _vm.laudo.dadoLaudoDto,
                                "cpfCnpj",
                                $event
                              )
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-row",
                      [
                        _c("app-display-com-input", {
                          attrs: {
                            marginBottom: true,
                            label: "Estado civil",
                            content: _vm.laudo.dadoLaudoDto.estadoCivil
                          },
                          on: {
                            "update:content": function($event) {
                              return _vm.$set(
                                _vm.laudo.dadoLaudoDto,
                                "estadoCivil",
                                $event
                              )
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-row",
                      [
                        _c("app-display-com-input", {
                          attrs: {
                            marginBottom: true,
                            label: "Telefones",
                            content: _vm.laudo.dadoLaudoDto.telefones
                          },
                          on: {
                            "update:content": function($event) {
                              return _vm.$set(
                                _vm.laudo.dadoLaudoDto,
                                "telefones",
                                $event
                              )
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-row",
                      [
                        _c("app-display-com-input", {
                          attrs: {
                            marginBottom: true,
                            label: "Email",
                            content: _vm.laudo.dadoLaudoDto.email
                          },
                          on: {
                            "update:content": function($event) {
                              return _vm.$set(
                                _vm.laudo.dadoLaudoDto,
                                "email",
                                $event
                              )
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-row",
                      [
                        _c("app-display-com-input", {
                          attrs: {
                            marginBottom: true,
                            label: "Renda familiar",
                            content: _vm.laudo.dadoLaudoDto.renda
                          },
                          on: {
                            "update:content": function($event) {
                              return _vm.$set(
                                _vm.laudo.dadoLaudoDto,
                                "renda",
                                $event
                              )
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c("app-divider", {
                      staticClass: "margim-bottom",
                      attrs: { label: "Informação de localização do imóvel" }
                    }),
                    _c(
                      "el-row",
                      [
                        _c("app-display-com-input", {
                          attrs: {
                            marginBottom: true,
                            label: "Nome do imóvel",
                            content: _vm.laudo.dadoLaudoDto.nomeImovel
                          },
                          on: {
                            "update:content": function($event) {
                              return _vm.$set(
                                _vm.laudo.dadoLaudoDto,
                                "nomeImovel",
                                $event
                              )
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-row",
                      [
                        _c("app-display-com-input", {
                          attrs: {
                            marginBottom: true,
                            label: "Município do imóvel",
                            content: _vm.laudo.dadoLaudoDto.municipioImovel
                          },
                          on: {
                            "update:content": function($event) {
                              return _vm.$set(
                                _vm.laudo.dadoLaudoDto,
                                "municipioImovel",
                                $event
                              )
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-row",
                      [
                        _c("app-display-com-input", {
                          attrs: {
                            marginBottom: true,
                            label: "Localização",
                            content: _vm.laudo.dadoLaudoDto.localizacaoImovel
                          },
                          on: {
                            "update:content": function($event) {
                              return _vm.$set(
                                _vm.laudo.dadoLaudoDto,
                                "localizacaoImovel",
                                $event
                              )
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c("app-divider", {
                      staticClass: "margim-bottom",
                      attrs: { label: "Dados da ocupação" }
                    }),
                    _c(
                      "el-row",
                      [
                        _c("app-display-com-input", {
                          attrs: {
                            marginBottom: true,
                            label: "Há ocupantes anteriores?",
                            content: _vm.laudo.dadoLaudoDto.ocupantesAnterior
                          },
                          on: {
                            "update:content": function($event) {
                              return _vm.$set(
                                _vm.laudo.dadoLaudoDto,
                                "ocupantesAnterior",
                                $event
                              )
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-row",
                      [
                        _c("app-display-com-input", {
                          attrs: {
                            marginBottom: true,
                            label: "Tem posse mansa e pacífica?",
                            content:
                              _vm.laudo.dadoLaudoDto.temPosseMansaPacifica
                          },
                          on: {
                            "update:content": function($event) {
                              return _vm.$set(
                                _vm.laudo.dadoLaudoDto,
                                "temPosseMansaPacifica",
                                $event
                              )
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-row",
                      [
                        _c("app-display-com-input", {
                          attrs: {
                            marginBottom: true,
                            label:
                              "É uma unidade autônoma produtiva e sem fracionamento?",
                            content:
                              _vm.laudo.dadoLaudoDto
                                .unidadeAutomaProdutivaSemFracionamento
                          },
                          on: {
                            "update:content": function($event) {
                              return _vm.$set(
                                _vm.laudo.dadoLaudoDto,
                                "unidadeAutomaProdutivaSemFracionamento",
                                $event
                              )
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-row",
                      [
                        _c("app-display-com-input", {
                          attrs: {
                            marginBottom: true,
                            label: "Tem atividade agrária?",
                            content: _vm.laudo.dadoLaudoDto.temAtividadeAgraria
                          },
                          on: {
                            "update:content": function($event) {
                              return _vm.$set(
                                _vm.laudo.dadoLaudoDto,
                                "temAtividadeAgraria",
                                $event
                              )
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c("app-divider", {
                      staticClass: "margim-bottom",
                      attrs: { label: "Documentos anexados" }
                    }),
                    _c("el-row", [
                      _c(
                        "div",
                        { staticClass: "container-item" },
                        [
                          _c(
                            "el-table",
                            {
                              staticStyle: { width: "100%" },
                              attrs: { data: _vm.documentosAnexadosConversa }
                            },
                            [
                              _c("el-table-column", {
                                attrs: { prop: "tipo.descricao", label: "Tipo" }
                              }),
                              _c("el-table-column", {
                                attrs: { prop: "nome", label: "Nome" }
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "isValido",
                                  align: "right",
                                  width: "180"
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function(scope) {
                                        return [
                                          _c(
                                            "div",
                                            { staticClass: "action-column" },
                                            [
                                              _vm.visualizarDocumentosPDF
                                                ? _c(
                                                    "el-tooltip",
                                                    {
                                                      staticClass:
                                                        "btn-actions",
                                                      attrs: {
                                                        effect: "dark",
                                                        placement: "top",
                                                        content:
                                                          "Visualizar Documento"
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        [
                                                          true
                                                            ? _c(
                                                                "el-button",
                                                                {
                                                                  staticClass:
                                                                    "button",
                                                                  attrs: {
                                                                    disabled: _vm.verificarExtensao(
                                                                      scope.row
                                                                    )
                                                                  },
                                                                  on: {
                                                                    click: function(
                                                                      $event
                                                                    ) {
                                                                      return _vm.abrirDocumento(
                                                                        scope.row
                                                                      )
                                                                    }
                                                                  }
                                                                },
                                                                [
                                                                  _c(
                                                                    "font-awesome-icon",
                                                                    {
                                                                      attrs: {
                                                                        icon:
                                                                          "eye",
                                                                        size:
                                                                          "lg"
                                                                      }
                                                                    }
                                                                  )
                                                                ],
                                                                1
                                                              )
                                                            : _vm._e()
                                                        ],
                                                        1
                                                      )
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _c(
                                                "el-tooltip",
                                                {
                                                  staticClass: "btn-actions",
                                                  attrs: {
                                                    effect: "dark",
                                                    content: "Baixar Documento",
                                                    placement: "top"
                                                  }
                                                },
                                                [
                                                  !scope.row
                                                    .isDocumentoAutenticavel
                                                    ? _c(
                                                        "el-button",
                                                        {
                                                          staticClass: "button",
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              return _vm.getDownload(
                                                                {
                                                                  id:
                                                                    scope.row
                                                                      .id,
                                                                  nome:
                                                                    scope.row
                                                                      .nome,
                                                                  caminho:
                                                                    scope.row
                                                                      .caminho
                                                                }
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "font-awesome-icon",
                                                            {
                                                              attrs: {
                                                                icon:
                                                                  "download",
                                                                size: "lg"
                                                              }
                                                            }
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    : _vm._e()
                                                ],
                                                1
                                              ),
                                              scope.row.isValido
                                                ? _c(
                                                    "div",
                                                    { staticClass: "valido" },
                                                    [
                                                      _c("font-awesome-icon", {
                                                        attrs: {
                                                          icon: "check",
                                                          size: "lg"
                                                        }
                                                      }),
                                                      _c("span", [
                                                        _vm._v("  Válido")
                                                      ])
                                                    ],
                                                    1
                                                  )
                                                : scope.row.isValido === false
                                                ? _c(
                                                    "div",
                                                    { staticClass: "invalido" },
                                                    [
                                                      _c("font-awesome-icon", {
                                                        attrs: {
                                                          icon: "times",
                                                          size: "lg"
                                                        }
                                                      }),
                                                      _c("span", [
                                                        _vm._v("  Inválido")
                                                      ])
                                                    ],
                                                    1
                                                  )
                                                : _vm._e()
                                            ],
                                            1
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  2475685657
                                )
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ]),
                    _c("el-row"),
                    _c("app-documentos", {
                      attrs: {
                        idUploadDocumento: "documentos",
                        titulo: "Documetos",
                        maxSize: 25000,
                        "valid-extensions": [
                          "png",
                          "jpg",
                          "jpeg",
                          "zip",
                          "pdf"
                        ],
                        documentos: _vm.laudo.documentos,
                        tiposDocumentos: _vm.tiposDocumento,
                        tiposDocumentosObrigatorios: _vm.tiposDocumento,
                        removeOutros: true,
                        idLaudoDiagnostico: _vm.laudo.id,
                        observer: _vm.$refs.validation,
                        aba: "documentos"
                      }
                    }),
                    _c(
                      "div",
                      { staticClass: "filter-row" },
                      [
                        _c("app-button", {
                          attrs: {
                            titulo: "Cancelar",
                            tipo: "default",
                            size: "medium",
                            icone: "times-circle",
                            method: "salvar"
                          },
                          on: {
                            salvar: function($event) {
                              return _vm.cancelar()
                            }
                          }
                        }),
                        _c("app-button", {
                          attrs: {
                            titulo: "Gerar Laudo",
                            tipo: "success",
                            size: "medium",
                            icone: "times-circle",
                            method: "salvar"
                          },
                          on: {
                            salvar: function($event) {
                              return _vm.salvar(_vm.laudo)
                            }
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4c892220", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4c892220","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/diagnostico/AnalisarLaudo.vue
// module id = null
// module chunks = 